import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import React from "react";
import "./index.css";

const name = "MiniTable";

const getBackgroundClass = (row: number) => {
    if (row < 3)
        return "background-color-green";
    if (row === 3)
        return "background-color-light-gray";
    return "background-color-red";

}

interface Props {
    data: any;
    inverted?: boolean;
}

const MiniTable: React.FC<Props> = ({ data, inverted }) => {
    return (<TableContainer component={Paper} sx={{ maxHeight: "15rem", overflow: "hidden" }}>
        <Table size="small" aria-label="a dense table" stickyHeader >
            <TableHead>
                <TableRow>
                    <TableCell sx={{ backgroundColor: "#2e3add", border: "1px solid #ffffff82", color: "#fff", fontSize: "10px", lineHeight: "0.3rem" }} align="center" size="small" colSpan={2}>{data.name}</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {inverted ? data && data.data.length > 0 && data.data.reverse().map((row: any, idx: number) => (
                    <TableRow
                        key={idx}
                        className={getBackgroundClass(idx)}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                        <TableCell align="left" sx={{ whiteSpace: "nowrap", fontSize: "9px", lineHeight: "0.3rem", paddingInline: 0.5 }}>{row.name}</TableCell>
                        <TableCell align="center" sx={{ whiteSpace: "nowrap", fontSize: "9px", lineHeight: "0.3rem", paddingInline: 0.5 }}>{row.rate}%</TableCell>
                    </TableRow>
                )) : data && data.data.length > 0 && data.data.map((row: any, idx: number) => (
                    <TableRow
                        key={idx}
                        className={getBackgroundClass(idx)}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                        <TableCell align="left" sx={{ whiteSpace: "nowrap", fontSize: "9px", lineHeight: "0.3rem", paddingInline: 0.5 }}>{row.name}</TableCell>
                        <TableCell align="center" sx={{ whiteSpace: "nowrap", fontSize: "9px", lineHeight: "0.3rem", paddingInline: 0.5 }}>{row.rate}%</TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    </TableContainer>)
}

MiniTable.displayName = name;

export default React.memo(MiniTable);